import { render, staticRenderFns } from "./connection-lost-popup.vue?vue&type=template&id=217930dc&scoped=true&"
import script from "./connection-lost-popup.vue?vue&type=script&lang=ts&"
export * from "./connection-lost-popup.vue?vue&type=script&lang=ts&"
import style0 from "./connection-lost-popup.vue?vue&type=style&index=0&id=217930dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217930dc",
  null
  
)

export default component.exports